import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import LoadingProgess from './components/layout/loading-progress';
import { isAdmin } from './services/account-service';
import useUser from './hooks/useUser';
import useAccount from './hooks/useAccount';
import { isLoaded, isLoggedIn } from './services/user-service';

/**
 *
 * @param {Object} data
 * @param {Boolean=} data.checkAdmin
 * @param {any} data.children
 * @param {any} data.path
 * @param {Boolean=} data.exact
 * @returns
 */
const LoggedInRoute = ({ checkAdmin, children, ...rest }) => {
  const user = useUser();
  const [account, currentAccount] = useAccount();

  const isUserLoaded = isLoaded({
    account,
    currentAccount,
    user,
  });
  const validateAdmin = () => {
    if (!checkAdmin) return true;
    return isAdmin(account);
  };

  if (isLoggedIn() && !isUserLoaded) {
    return <LoadingProgess />;
  }

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const validated = validateAdmin();
        return isLoggedIn() && validated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: validated ? location : { pathname: '/' } },
            }}
          />
        );
      }}
    />
  );
};

LoggedInRoute.defaultProps = {
  checkAdmin: false,
};

LoggedInRoute.propTypes = {
  checkAdmin: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.func]).isRequired,
};

export default LoggedInRoute;
